﻿import React, { useState } from 'react'
import { useDispatch, useStore, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import IntlMessages from '../../util/IntlMessages'
import { Button, Row, Col, Modal, Form, Drawer } from 'antd'
import PaymentPanelAction from './PaymentPanelAction'
import { loadSingleScreenPay } from '../../appRedux/actions'
import { CloseOutlined } from '@ant-design/icons'

const SingleScreenCartModal = (props) => {
  const {
    storeCreditPerm,
    returnStoreCredit,
    getLaySalePerm,
    getAccountSalePerm,
    allowPrint,
    outletName,
    registerName,
    outletid,
  } = props;
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: "",
        currencyName: "",
        currencySymbol: "",
      };
  const dispatch = useDispatch();

  const showScreenPay = useSelector(({ MainSale }) => MainSale.showScreenPay);

  const [getMoreActionsOptions, setMoreActionsOptions] = React.useState([]);

  return (

    <Drawer title="Payment" className='Payment-Drawer'
      onClose={() => dispatch(loadSingleScreenPay(false))}
      visible={showScreenPay}
    >
     
      <PaymentPanelAction
        getCurrData={getCurrData}
        storeCreditPerm={storeCreditPerm}
        returnStoreCredit={returnStoreCredit}
        getLaySalePerm={getLaySalePerm}
        getAccountSalePerm={getAccountSalePerm}
        outletid={outletid}
        allowPrint={allowPrint}
        singleScreen={true}
      />
    </Drawer>
  )
}

export default SingleScreenCartModal;
